import { styled } from 'troyfe';

const LoginForm = styled.div`
  width: 100vw;
  height: 100vh;
  background: #fff;
  overflow: hidden;
  .login_content {
    img {
      width: 100%;
      height: 6.4rem;
    }
    position: absolute;
    width: 21%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .form {
      margin-top: 4rem;
      input {
        height: 4.8rem;
      }
      .ant-input-affix-wrapper-lg {
        padding: 0 11px;
      }
    }
    .submit {
      width: 100%;
      background: #44bb55;
      border: none;
      font-size: 1.8rem;
      height: 4.8rem;
      margin-top: 1.6rem;
    }
    .tip {
      text-align: center;
      margin-top: 4rem;
      font-size: 0.88rem;
      color: #999999;
    }
  }
`;

export { LoginForm };
